import React, { useEffect, useState } from 'react';
import 'swiper/css';
import 'swiper/css/free-mode';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import SingleToast from '../SingleToast/SingleToast';
import {
	MapToastsCount,
	MapToastsSwiper,
	MapToastsSwiperContainer,
	MapToastsSwiperSlide,
} from '../../../Global/DumbMap/subComponents/mapToastsStyles';
import { Trail } from '../../../../models/Trail';

type ToastProps = {
	trails: Trail[];
	setActiveIndex: React.Dispatch<React.SetStateAction<any>>;
	onSelectTrail?: () => void;
};

const ClusterToasts: React.FC<ToastProps> = ({
	trails,
	setActiveIndex,
	onSelectTrail,
}) => {
	const [swiper, setSwiper] = useState<any>({});
	const [progress, setProgress] = useState(1);
	const [total, setTotal] = useState(0);
	const handleSlideChange = () => {
		const currentProgress = swiper.realIndex + 1;
		setProgress(currentProgress);
		setActiveIndex(currentProgress - 1);
	};

	useEffect(() => {
		//		setTotal(swiper?.slides?.length);
		setTotal(trails.length);
	}, [swiper?.slides?.length]);

	return (
		<MapToastsSwiperContainer>
			<MapToastsCount>
				<p>
					{progress}/{total}
				</p>
			</MapToastsCount>
			<MapToastsSwiper
				// pagination={{
				// 	type: 'fraction',
				// }}
				slidesPerView={'auto'}
				spaceBetween={8}
				onSlideChange={() => handleSlideChange()}
				onSwiper={(swiper) => setSwiper(swiper)}
				// navigation={true}
				// modules={[Pagination, Navigation]}
			>
				{trails.map((trail) => {
					return (
						<MapToastsSwiperSlide key={trail.id}>
							<SingleToast trail={trail} onSelect={onSelectTrail} />
						</MapToastsSwiperSlide>
					);
				})}
			</MapToastsSwiper>
		</MapToastsSwiperContainer>
	);
};

export default ClusterToasts;
